import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    boxShadow: '0px 1px 4px rgba(0,0,0,0.04)',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(1.75)
    }
  } as SxProps,

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0
  } as SxProps,

  cardTitle: {
    color: '#1F2937',
    fontSize: 15,
    fontWeight: 700,
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: 14
    }
  } as SxProps,

  cardTitleOrderId: {
    color: '#a4aab5',
    fontSize: 15,
    fontWeight: 700,
    [theme.breakpoints.down('md')]: {
      fontSize: 14
    }
  } as SxProps,

  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: '8px',
    backgroundColor: '#EFF6FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: 28,
      height: 28,
      borderRadius: '6px'
    }
  } as SxProps,

  chipsRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    flexWrap: 'wrap'
  } as SxProps,

  chip: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.625),
    height: 28,
    padding: theme.spacing(0, 1.25),
    borderRadius: '20px',
    backgroundColor: '#F3F4F6',
    border: '1px solid #E5E7EB'
  } as SxProps,

  chipText: {
    color: '#374151',
    fontSize: 12,
    fontWeight: 500
  } as SxProps,

  fragileChip: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.625),
    height: 28,
    padding: theme.spacing(0, 1.25),
    borderRadius: '20px',
    backgroundColor: '#FFFBEB',
    border: '1px solid #FDE68A'
  } as SxProps,

  fragileChipText: {
    color: '#92400E',
    fontSize: 12,
    fontWeight: 600
  } as SxProps,

  desktopDivider: {
    height: 1,
    backgroundColor: '#F3F4F6',
    width: '100%'
  } as SxProps,

  itemsSubHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  itemsSubHeaderTitle: {
    color: '#1F2937',
    fontSize: 14,
    fontWeight: 600
  } as SxProps,

  itemsBadge: {
    backgroundColor: '#F5F3FF',
    borderRadius: '13px',
    height: 26,
    padding: theme.spacing(0, 1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  } as SxProps,

  itemsBadgeText: {
    color: '#6D28D9',
    fontSize: 12,
    fontWeight: 600
  } as SxProps,

  desktopItemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  } as SxProps,

  desktopItemRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0),
    width: '100%'
  } as SxProps,

  desktopItemImgBox1: {
    width: 48,
    height: 48,
    minWidth: 48,
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #EDE9FE 0%, #DBEAFE 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  } as SxProps,

  desktopItemImgBox2: {
    width: 48,
    height: 48,
    minWidth: 48,
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #ECFDF5 0%, #DBEAFE 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  } as SxProps,

  desktopItemInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    flex: 1,
    alignItems: 'flex-start',
    minWidth: 0
  } as SxProps,

  desktopItemTitle: {
    color: '#1F2937',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'left'
  } as SxProps,

  desktopItemDivider: {
    height: 1,
    backgroundColor: '#F3F4F6',
    width: '100%'
  } as SxProps,

  desktopItemFragileChip: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    height: 24,
    padding: theme.spacing(0, 1.25),
    borderRadius: '6px',
    backgroundColor: '#FFFBEB',
    border: '1px solid #FDE68A'
  } as SxProps,

  desktopItemFragileChipText: {
    color: '#92400E',
    fontSize: 12,
    fontWeight: 600
  } as SxProps
}

export const getDesktopItemImgBoxStyle = (index: number): SxProps =>
  index % 2 === 0 ? styles.desktopItemImgBox1 : styles.desktopItemImgBox2

export default styles
